export type ProvisioningFlowStep =
  | typeof SELECT_PROVISIONING_STEP
  | typeof NEW_INSTANCE_STEP
  | typeof EXISTING_INSTANCE_STEP;

export type ServiceProvisioningFlowStep =
  | 'NEW_ACCOUNT_STEP'
  | 'EXISTING_ACCOUNT_STEP';

export const SELECT_PROVISIONING_STEP = 'SELECT_PROVISIONING_STEP';
export const NEW_INSTANCE_STEP = 'NEW_INSTANCE_STEP';
export const EXISTING_INSTANCE_STEP = 'EXISTING_INSTANCE_STEP';

export const NEW_ACCOUNT_STEP = 'NEW_ACCOUNT_STEP';
export const EXISTING_ACCOUNT_STEP = 'EXISTING_ACCOUNT_STEP';

export const DEFAULT_FIRST_STEP = NEW_INSTANCE_STEP;
export const DEFAULT_SERVICE_FIRST_STEP = NEW_ACCOUNT_STEP;

export const PROVISION_IN_PROGRESS = 'IN_PROGRESS';
export type ProvisioningStatus = typeof PROVISION_IN_PROGRESS;

export const AUTO_APPLY_TO_LEGACY_PRODUCT = 'AUTO_APPLY_TO_LEGACY_PRODUCT';
export const AUTO_APPLY_TO_EXISTING_PRODUCT = 'AUTO_APPLY_TO_EXISTING_PRODUCT';
export const AUTO_APPLY_PAID_TO_TRIAL = 'AUTO_APPLY_PAID_TO_TRIAL';
export const TRIAL_QUANTITY_LESS_THAN_PAID = 'TRIAL_QUANTITY_LESS_THAN_PAID';
export const EXTERNAL_SUBSCRIPTION_EXISTS = 'EXTERNAL_SUBSCRIPTION_EXISTS';
export const TRIAL_CLAIM_BLOCKED_DUE_TO_EA_IN_PROGRESS =
  'TRIAL_CLAIM_BLOCKED_DUE_TO_EA_IN_PROGRESS';
export const AUTO_APPLY_ORG_LICENSES_TO_EXISTING_PRODUCT =
  'CLEAN_UP_EXISTING_ENTITLEMENTS';
export const PRODUCT_ALREADY_EXISTS = 'PRODUCT_ALREADY_EXISTS';

export const BLOCKED = 'BLOCKED';
export const WARNING = 'WARNING';
export const STANDALONE_WARNING = 'STANDALONE_WARNING';
export const INFO = 'INFO';

export const deactivateProducts = [
  'Cisco Multicloud Defense',
  'Cisco Defense Orchestrator',
];
export const DISABLE_SASE_PROVISIONING_FOR_SINGLE_TENANCY_TYPES = [
  AUTO_APPLY_TO_LEGACY_PRODUCT,
  AUTO_APPLY_TO_EXISTING_PRODUCT,
  AUTO_APPLY_PAID_TO_TRIAL,
  TRIAL_CLAIM_BLOCKED_DUE_TO_EA_IN_PROGRESS,
  AUTO_APPLY_ORG_LICENSES_TO_EXISTING_PRODUCT,
  PRODUCT_ALREADY_EXISTS,
];
